import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from '../store';
Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes:{
      light:{
        primary: "#F57D22",
        secondary: '#32DE8A',
        green: '#32DE8A',
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        grey_light: '#F1F3F7',
        input: '#dee0e4',
        blue_drop: '#2F80ED',
          new_blue_drop: '#4353FF',
        blue_inactive: '#7aabed',
        blue: '#2F80ED',
        super_light_blue: '#D9EAF3',
        light_grey: '#E0E0E0'
      }
    },
  },
  customProperties: true
});

